import { Avatar as BaseAvatar } from '@base-ui/react/avatar'
import { forwardRef, type HTMLAttributes, type ImgHTMLAttributes } from 'react'
import styles from './avatar.module.css'

export interface AvatarProps extends HTMLAttributes<HTMLSpanElement> {
  src?: string
  alt?: string
  imgProps?: ImgHTMLAttributes<HTMLImageElement>
  size?: 'small' | 'medium' | 'large'
}

export const Avatar = forwardRef<HTMLSpanElement, AvatarProps>(
  ({ src, alt, imgProps, size = 'medium', className, children, style, ...rest }, ref) => {
    const classes = [
      styles.avatar,
      size === 'small' ? styles.small : undefined,
      size === 'large' ? styles.large : undefined,
      className,
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <BaseAvatar.Root ref={ref} className={classes} style={style} {...rest}>
        {src ? <BaseAvatar.Image src={src} alt={alt ?? ''} {...imgProps} /> : null}
        <BaseAvatar.Fallback>{children}</BaseAvatar.Fallback>
      </BaseAvatar.Root>
    )
  }
)

Avatar.displayName = 'Avatar'
